module.exports = __webpack_public_path__ + "static/children_ny-3b261e39bffb591b2822c9707f1a5486.jpg";